import { EwayVehiclListDetail } from './EwayVehiclListDetail';
import { EwayItemList } from './EwayItemList';
export class EwayBill {
    public status!: string;
    public eway_bill_number!: string;
    public eway_bill_date!: string;
    public eway_bill_valid_date!: string;
    public number_of_valid_days!: string;
    public eway_bill_status!: string;
    public generate_mode!: string;
    public userGstin!: string;
    public supply_type!: string;
    public sub_supply_type!: string;
    public document_type!: string;
    public document_number!: string;
    public document_date!: string;
    public gstin_of_consignor!: string;
    public legal_name_of_consignor!: string;
    public address1_of_consignor!: string;
    public address2_of_consignor!: string;
    public place_of_consignor!: string;
    public pincode_of_consignor!: string;
    public state_of_consignor!: string;
    public actual_from_state_name!: string;
    public gstin_of_consignee!: string;
    public legal_name_of_consignee!: string;
    public address1_of_consignee!: string;
    public address2_of_consignee!: string;
    public place_of_consignee!: string;
    public pincode_of_consignee!: string;
    public state_of_supply!: string;
    public actual_to_state_name!: string;
    public total_invoice_value!: string;
    public taxable_amount!: string;
    public sgst_amount!: string;
    public cgst_amount!: string;
    public igst_amount!: string;
    public cess_amount!: string;
    public transporter_id!: string;
    public transporter_name!: string;
    public transportation_distance!: string;
    public extended_times!: string;
    public reject_status!: string;
    public transaction_type!: string;
    public other_value!: string;
    public cess_nonadvol_value!: string;
    public itemList: EwayItemList[] = [];
    public VehiclListDetails: EwayVehiclListDetail[] = [];
}